import palette from '../../colors/palette';

export default {
  root: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)'
    },
    color: palette.icon,
    padding: 0,
  }
};
